import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    linkListContainer?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            background-color: #000;
            margin: 0 auto;
            max-width: 100% !important;
            > ${GridOffset} {
                margin: 0px auto;
                max-width: 1280px;
                padding: 20px 0 15px 15px;
                width: 100%;
                justify-content: space-between;
                > ${GridItemStyle} {
                    gap: 90px;
                    padding: 20px 10px 0 0;
                    width: 100%;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    flex-direction: column;
                                    gap: 0 !important;
                                `,
                                css`
                                    flex-direction: column;
                                    gap: 0 !important;
                                `,
                                css`
                                    flex-direction: column;
                                    gap: 0 !important;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                    > ${GridItemStyle} {
                        width: 100%;
                        padding: 0;
                        flex-basis: content;
                    }
                    &:last-child {
                        padding-top: 30px;
                        color: #ffffff;
                        text-align: center;
                        font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
                        > div > div > div > ${TypographyStyle} {
                            font-size: 13px;
                            line-height: 20px;
                            letter-spacing: 0.2px;
                            font-weight: 600;
                            margin-bottom: 1rem;
                            > a > span {
                                color: #f08000;
                            }
                        }
                    }
                }
            }
        `,
    },
    logoGridItem: {
        css: css`
            width: 100%;
            display: flex;
            padding: 0;
            img {
                height: auto;
                width: 220px;
            }
        `,
    },
    linkList1GridItem: {
        width: [12, 12, 12, 2, 2],
    },
    linkList2GridItem: {
        width: [12, 12, 12, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            > div {
                > div {
                    > div {
                        max-width: 100%;
                        a {
                            background: transparent !important;
                            border: none !important;
                            padding: 0;
                        }
                    }
                }
            }
        `,
    },
    linkListContainer: {
        width: [12, 12, 12, 10, 10],
        css: css`
            justify-content: flex-end;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.logoGridItem}>
                <StyledWrapper {...styles.logoWrapper}>
                    <Zone zoneName="Logo" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkListContainer}>
                <GridItem {...styles.linkList1GridItem}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </GridItem>
                <GridItem {...styles.linkList2GridItem}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </GridItem>
            </GridItem>
            {/* <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <Zone zoneName="LinkList3" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <Zone zoneName="LinkList4" contentId={id} />
            </GridItem>
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
            <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.siteMapLinksGridItem}>
                <Zone zoneName="SiteMapLinks" contentId={id} />
            </GridItem> */}
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
